import { render } from "./TenantPaymentGatewaysManagement.vue?vue&type=template&id=41646374"
import script from "./TenantPaymentGatewaysManagement.vue?vue&type=script&lang=js"
export * from "./TenantPaymentGatewaysManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__